import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getVehicleIdFromStockNumber } from '|/app/purchase/flow/guided-flow/services';
import AppFrameworkContext from '|/helpers/app-framework';

const useGuidedFlowVm = () => {
  const { search } = useLocation();
  const { load } = useContext(AppFrameworkContext);
  const [newRoute, setNewRoute] = useState<null | string>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);

    const stockNumberNumber = parseInt(searchParams.get('stock-number') ?? '');
    const stockNumber = Number.isNaN(stockNumberNumber) ? null : stockNumberNumber;

    if (stockNumber !== null) {
      load(
        getVehicleIdFromStockNumber(`${stockNumber}`).then(vehicleId => {
          setNewRoute(`/?vehicle-id=${vehicleId}`);
          return null;
        })
      ).catch(() => void 0);
      return;
    }

    const vehicleIdNumber = parseInt(searchParams.get('vehicle-id') ?? '');
    const vehicleId = Number.isNaN(vehicleIdNumber) ? null : vehicleIdNumber;

    if (vehicleId !== null) {
      setNewRoute(`/vehicle/${vehicleId}`);
      return;
    }
    const returnUrl = searchParams.get('return-url');

    if (returnUrl) {
      setNewRoute(`/next-step?returnUrl=${encodeURIComponent(returnUrl)}`);
    } else {
      setNewRoute('/next-step');
    }
  }, [load, search]);

  return newRoute;
};

export default useGuidedFlowVm;
